import {differenceInCalendarDays} from 'date-fns';
import {toJstDate} from '../../../shared/services/dateUtils';

/*
- true: 本日/明日/明後日
- false: その他
*/

type DeadlineStatus = {
  isHighlight: boolean;
  text: string;
};

export const getDeadlineStatus = (deadline: Date): DeadlineStatus => {
  const dayLabels = ['本日', '明日', '明後日'];

  // JSTで本日から何日後かを求める
  const diffDays = differenceInCalendarDays(
    toJstDate(deadline),
    toJstDate(new Date()),
  );

  const label = diffDays >= 0 ? dayLabels[diffDays] : undefined;
  if (label !== undefined) {
    return {isHighlight: true, text: label};
  }

  return {isHighlight: false, text: ''};
};
